import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import classNames from "classnames";
export default class MealImage extends React.PureComponent {
    render() {
        let imageName = "";
        if (this.props.images.length == 0) {
            imageName = `/assets/images/no-image-s.jpg`;
        }
        else {
            var image = this.props.images[0];
            imageName = `/assets/products/${image.filename}-s.${image.filetype}`;
        }
        return (React.createElement(LazyLoadImage, { src: `${imageName}`, width: "250", height: "250", effect: "opacity", className: classNames("img-fluid card-img-top", {
                "dm-inverse": this.props.images.length == 0
            }) }));
    }
}
